import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import type QuestionConfig from 'modules/surveys/store/models/QuestionConfig'

interface QuestionPositionProps {
  questionConfig: QuestionConfig
}

export default function QuestionPosition({ questionConfig }: QuestionPositionProps) {
  const archived = questionConfig.attributes.archived

  return (
    <Box
      height="s24"
      width="s24"
      background={archived ? 'grey400' : 'viridian200'}
      borderRadius={{
        all: 'rel333',
      }}
      justifyContent="center"
      alignItems="center"
    >
      {archived ? (
        <Icon.Medium icon="archive" color={archived ? 'grey600' : 'viridian600'} />
      ) : (
        <Text.Normal size="200" weight="semibold">
          {questionConfig.attributes.position + 1}
        </Text.Normal>
      )}
    </Box>
  )
}
